import script from "./HomeBannerFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeBannerFrame.vue?vue&type=script&setup=true&lang=js"

import "@/features/home/styles/HomeBannerFrame.css?vue&type=style&index=0&id=7f161f38&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f161f38"]])

export default __exports__